
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item> 手续费设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="float: right;margin-right:2%;display: flex;align-items: center;">
        <span style="margin: 8px;background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">一键批量所有队伍费率：
             <el-button size="mini" type="danger" @click="updateAllTeamFeeTo()">修改</el-button></span>
        <span style="background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">队伍创建的初始服务费：
            {{teamFeeInfo.totalFee}}% <el-button size="mini" type="danger" @click="updateCSFWTo()">修改</el-button></span>
        <input placeholder="输入网点名称的关键字进行搜索" v-model="outlet" style='margin: 10px 0;width: 200px;margin: 8px;'></input>
        <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document" @click="dataSelect">搜索</el-button> 
            <!-- <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document"><el-upload class="avatar-uploader" v-model="img"
             action="https://admin.shengqianxiong.com.cn/tao/upload" :show-file-list="false"
             :on-success="handleAvatarSuccess">新增</el-upload></el-button> -->
            <!-- <img v-if="img" :src="img" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
    </div>

    <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column
      type="selection"
      width="55">
      </el-table-column>
			<!-- <el-table-column  prop="id" label="编号" width="80">
			</el-table-column> -->
			<el-table-column align="center" prop="outlet" label="网点名称">
			</el-table-column>
      <el-table-column align="center" prop="business" label="业务名称">
			</el-table-column>
            <el-table-column align="center" prop="phone" label="联系电话">
			</el-table-column>
			<el-table-column align="center" prop="premium" label="服务费">
                <template slot-scope="scope">
                    <div v-if="scope.row.premium ===null">0%</div>
                    <div v-if="scope.row.premium !==null">{{scope.row.premium}}%</div>
                </template>
			</el-table-column>
			<el-table-column align="center" label="操作" width="240px">
				<template slot-scope="scope">
					<el-button size="mini" type="primary"
						@click="openDialogFormVisible(scope.row)">服务费修改
					</el-button>
				</template>
			</el-table-column>
		</el-table>

    <el-dialog title=" 手续费设置" :visible.sync="dialogFormVisible" center>
        <div style="margin-bottom: 10px;">
            <span style="width: 200px;display: inline-block;text-align: right;">网点名称：</span>
            <span>{{ updateForm.outlet }}</span>
        </div>
        <div style="margin-bottom: 10px;">
            <span style="width: 200px;display: inline-block;text-align: right;">业务名称：</span>
            <span>{{ updateForm.business }}</span>
        </div>
        <div style="margin-bottom: 10px;">
            <span style="width: 200px;display: inline-block;text-align: right;">服务费：</span>
            <el-input style="width:50%;" type="number" v-model="updateForm.premium" placeholder="请输入服务费"></el-input>
            <span style="color: red;">(整数数字)</span>
        </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateTeamFWF()">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog title=" " :visible.sync="dialogFormVisible2" center>
        <h1 style="width: 100%;display: inline-block;text-align: center;">服务费设置</h1>
        <div style="margin-bottom: 10px;">
            <span style="width: 200px;display: inline-block;text-align: right;">队伍初始服务费：</span>
            <el-input style="width:50%;" v-model="upTeamFeeInfo.totalFee" placeholder="输入新的队伍创建的初始服务费(整数数字)"></el-input>
        </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="updateCSFWT()">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog title="所有队伍" :visible.sync="dialogFormVisible3" center>
        <h1 style="width: 100%;display: inline-block;text-align: center;">请输入新的费率，只能整数(没测试小数，可能导致意外的结果)</h1>
        <div style="margin-bottom: 10px;">
            <el-input v-model="totalFee" placeholder="请输入新的费率，只能整数(没测试小数，可能导致意外的结果)"></el-input>
        </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="updateAllTeamFeeT()">添 加</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { updateAllTeamFee , getTeamFeeInfo , getHotTeamList , updateTeamFee , updateTeamFeeInfo} from '../../../api/manage/team.js'

import { addAdvertisingPackages , deleteAdvertisingPackages , getAdvertisingPackagesList , updateAdvertisingPackages } from '../../../api/manage/advertisingPackages.js'

import moment from 'moment';

export default {
  data() {
    return {
        totalFee:'',
        fee:'',
        teamFeeInfo:[],
        upTeamFeeInfo:[],
        outlet : '',
        multipleSelection: [],
        totalnum:0,
        page : 1 ,
        size : 10,
        tableDataLoading:false,
        dialogFormVisible:false,
        dialogFormVisible2:false,
        dialogFormVisible3:false,
        tableData:[],
       
        updateForm:{
            
        },

    }
  },
  components: {

  },

  created() {
    this.dataSelect();
    this.dataGetTeamFeeInfo()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    updateAllTeamFeeTo(){
        this.dialogFormVisible3 = true
        
    },
    updateAllTeamFeeT(){
        let post = {
            fee : this.totalFee
        }
        this.dialogFormVisible3 = false
        updateAllTeamFee(post).then((res) => {
            this.$message({
                type: "success",
                message: res.msg,
                duration: 1500,
                onClose: () => {
                    this.dataSelect()
                    this.dataGetTeamFeeInfo()
                }
            });
        })
    },

    updateCSFWTo(){
        this.upTeamFeeInfo=JSON.parse(JSON.stringify(this.teamFeeInfo));
        this.dialogFormVisible2 = true
    },

    updateCSFWT(){
        let post = {
            id : this.upTeamFeeInfo.id,
            fee : this.upTeamFeeInfo.totalFee
        }
        this.dialogFormVisible2 = false
        updateTeamFeeInfo(post).then((res) => {
            this.$message({
                type: "success",
                message: res.msg,
                duration: 1500,
                onClose: () => {
                    this.dataSelect()
                    this.dataGetTeamFeeInfo()
                }
            });
        })
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    updateTeamFWF(){
        // addForm;
        let post = {
            teamIds : this.updateForm.id,
            fee : this.updateForm.premium
        }
        updateTeamFee(post).then((res) => {
            this.dialogFormVisible = false
            this.$message({
                type: "success",
                message: res.msg,
                duration: 1500,
                onClose: () => {
                    this.dataSelect()
                }
            });
        })

    },

    deletes(id){
      let obj = {
          id:id,
      }
      this.$confirm(`确定删除此条信息?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAdvertisingPackages(obj).then(res => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => {})
    },

    dataSelect(){
      let post = {
        page : (this.page - 1 ) * this.size,
        size : this.size,
        outlet: this.outlet
      }
      this.tableDataLoading = true
      getHotTeamList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
            // this.tableData = res.data.data;
            // res.data.data.forEach(item => {
            //   // console.log(item.createTime);
            //   item.createTime=moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
            //   // 
            // });
            this.tableData = res.data.list
            // console.log('this.tableDatathis.tableData',this.tableData)
            this.totalnum = res.data.count;
            return;
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
    })

    },

    dataGetTeamFeeInfo(){
        let post = {}
      getTeamFeeInfo(post).then((res) => {
        if (res.code == 200) {
            this.teamFeeInfo=res.data.data
            return;
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
    })

    },

     // 添加分类弹框
    openDialogFormVisible(row) {
        this.updateForm = JSON.parse(JSON.stringify(row));
        this.dialogFormVisible = true
    },

  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/premium/index.vue